import React from 'react';
import { BOT_USERNAME } from '../config/game_config';
import { buildSyndicateInviteLink, shareSyndicateInvite } from '../config/telegramLaunch';
import { gameState } from '../game/state/GameState';
import { trackShare } from '../game/meta/analytics';

const ShareCard = ({ model, pct = 100, slicesSolved = 0, syndicateId, tier }) => {
    const bot = BOT_USERNAME || 'voxelquest_bot';
    const sid = syndicateId || gameState.currentSquadId;
    const sname = gameState.currentSquadName;
    const carve =
        (tier || gameState.mysteryTier) === 'atelier' ? 'Atelier carve' : 'Workshop carve';

    const share = async () => {
        const result = await shareSyndicateInvite(sid, sname);
        trackShare(result, {
            source: 'share_card',
            tier: tier || gameState.mysteryTier || 'workshop',
            modelId: model?.id || '',
        });
        if (result === 'failed') {
            const link = buildSyndicateInviteLink(sid);
            alert(`Share manually:\n${link}`);
        }
    };

    return (
        <div className="atelier-share-card">
            <div className="atelier-share-top">
                <span className="atelier-share-label">{carve.toUpperCase()}</span>
                <span className="atelier-share-meta">VOXEL QUEST · @{bot}</span>
            </div>
            <div className="atelier-share-headline">I helped solve today&apos;s VOXEL QUEST</div>
            <div className="atelier-share-name">{model?.name || 'Mystery'}</div>
            <div className="atelier-share-stats">
                {carve} · Completion: {pct}% · My slices: {slicesSolved}
            </div>
            <button type="button" className="atelier-share-btn" onClick={share}>
                Invite friends in Telegram
            </button>
        </div>
    );
};

export default ShareCard;
